<template>
  <v-container fluid>
    <main-header-plat-a />
    <main-header-plat-b :navBItems="schema.navBItems" />
    <v-overlay-loader />
    <v-row class="flex-nowrap">
      <div class="barLateral">
        <v-nav-draw-anam :anamIndex="anamIndex" :anamGroupShow="anamGroupShow" />
      </div>
      <div class="contentCentral">
        <v-card-form-anam :anamRoute="schema.anamRoute" :observerHCP="observerHCP" />
        <v-card class="contentCardCentral secundary5 mx-2" flat>
          <v-table-correctors-done
            class="mx-auto"
            :headersTable="schema.headersTable"
            :coList="coApplied"
            :coBtnAdd="schema.coBtnAdd"
            :editItem="editItem"
            :deleteItem="deleteItem"
            :observerHCP="observerHCP"
            :downloadItem="downloadItem"
          />
        </v-card>
      </div>
      <v-overlay
        :value="overlay"
        @update:value="overlay = $event"
        class="d-flex align-star justify-center"
        style="z-index: 1000; position: absolute"
      >
        <v-row class="d-flex justify-center my-5">
          <v-card min-height="200" width="70%" class="secundary6">
            <v-card-title class="text-body-1 font-weight-bold justify-center">
              Aviso
            </v-card-title>
            <v-card-text class="text-body-2">
              {{ overlayMessage }}
            </v-card-text>
            <v-card-actions class="mx-auto mb-5">
              <v-btn
                color="primary"
                class="d-flex mx-auto justify-center"
                @click="toggleOverlay()"
              >
                IR A INDEX
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-row>
      </v-overlay>
    </v-row>
    <v-overlay v-model="overlayCal" class="d-flex align-end" style="z-index: 1000; position: absolute">
      <v-row class="mb-2 ml-16" style="width: 200px">
        <v-col cols="12" class="ma-0 pa-0 text-primary">
          <span class="d-flex text-subtitle-2 justify-center">Calculando</span>
        </v-col>
        <v-col cols="12" class="d-flex mx-auto justify-center">
          <v-progress-circular
            class="mx-auto"
            color="primary"
            indeterminate
            rounded
            height="7"
          ></v-progress-circular>
        </v-col>
      </v-row>
    </v-overlay>
    <v-snack-bar :snackbar="snackbar" />
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import MainHeaderPlatA from '@/components/includes/MainHeaderPlatA.vue';
import MainHeaderPlatB from '@/components/includes/MainHeaderPlatB.vue';
import VOverlayLoader from '@/components/base/VOverlayLoader.vue';
import VNavDrawAnam from '@/components/base/VNavDrawAnam.vue';
import VCardFormAnam from '@/components/base/VCardFormAnam.vue';
import VTableCorrectorsDone from '@/components/base/VTableCorrectorsDone.vue';
import VSnackBar from '@/components/base/VSnackBar.vue';

export default {
  name: 'ProPatientsCTestsPage',
  components: {
    MainHeaderPlatA,
    MainHeaderPlatB,
    VOverlayLoader,
    VNavDrawAnam,
    VCardFormAnam,
    VTableCorrectorsDone,
    VSnackBar,
  },
  props: ['navBItems', 'anamRoute', 'coBtnAdd', 'headersTable'],
  data() {
    return {
      overlayMessage: '',
      overlay: false,
    };
  },

  computed: {
    ...mapGetters('testCOxList', ['schema', 'coApplied', 'overlayCal', 'status']),
    ...mapGetters('anamPermissions', ['anamIndex', 'anamGroupShow', 'hasPermission', 'observerHCP']),
    ...mapGetters('notifications', ['snackbar']),

    overlayCal: {
      get() {
        return this.$store.getters['testCOxList/overlay'];
      },
      set(val) {
        this.$store.dispatch('testCOxList/toggleOverlay', val);
      },
    },
  },

  mounted() {
    this.loadData();
  },

  methods: {
    ...mapActions('testCOxList', ['fetchSchema', 'loadDataTest', 'coResultDownload']),
    ...mapActions('anamPermissions', ['loadPermissionsHCP', 'sectionsHCPandRoute', 'checkPermission', 'loadObserverHCP']),
    ...mapActions('notifications', ['triggerSnackbar']),

    async loadData() {
      await this.$store.dispatch('testCOxList/toggleOverlay', true);
      try {
        await Promise.all([
          this.fetchSchema(),
          this.sectionsHCPandRoute(this.$route),
        ]);

        if (this.hasPermission) {
          await this.loadDataTest();
        } else {
          this.overlay = true;
          this.overlayMessage = 'No tiene acceso a esta sección. Solicite permisos.';
        }
      } catch (error) {
        this.handleDataError(error, 'Error al cargar datos.');
      } finally {
        await this.$store.dispatch('testCOxList/toggleOverlay', false);
      }
    },

    toggleOverlay() {
      this.overlay = !this.overlay;
      if (!this.overlay && this.$route.name !== 'index') {
        this.$router.replace({ name: 'index' });
      }
    },

    handleDataError(error, message) {
      console.error(message, error);
      this.showSnackbar(message, 'error');
    },

    editItem(item) {
      this.$store.commit('auth/setCoNew', false);
      this.$store.commit('auth/setCoNumId', item.coNumId);
      this.$store.commit('auth/setCoEvaNum', item.evalNumber);
      this.$router.push({ name: `co-${item.coPlat.substring(4, 7)}` });
    },

    deleteItem(item) {
      let model = {
        correctorId: item.correctorId,
        coNameNum: item.coPlat.substring(4, 7),
      };
      this.$store.dispatch('testCOxList/deleteCo', model).then(() => {
        this.reload();
        this.snackbarOpen();
      }).catch(() => {
        this.reload();
        this.snackbarOpen();
      });
    },

    downloadItem(item) {
      this.overlayCal = true;
      this.$store.dispatch('testCOxList/coResultDownload', { item });
    },

    reload() {
      this.$store.dispatch('testCOxList/loadDataTest');
    },

    snackbarOpen() {
      this.snackbar.visible = false;
      if (this.status === 'success') {
        this.snackbar.visible = true;
        this.snackbar.content = this.schema.snackOk;
      } else if (this.status === 'removed') {
        this.snackbar.visible = true;
        this.snackbar.content = this.schema.snackOkRemoved;
      } else if (this.status === 'error') {
        this.snackbar.visible = true;
        this.snackbar.content = this.schema.snackError;
      }
    },

    showSnackbar(content, color) {
      this.triggerSnackbar({ content, color });
    },

    sanitizeText(text) {
      return text.replace(/</g, '&lt;').replace(/>/g, '&gt;');
    },
  },
};
</script>

<style>
.barLateral {
  min-width: 60px;
}

.contentCentral {
  width: 96%;
}

.contentCardCentral {
  width: 98.5%;
  margin-top: 90px;
}

.contentRowCentral {
  width: 80%;
  min-height: 400px;
}

.bannerAction {
  width: 87%;
  height: 48px;
}
</style>
